import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InteractionService {

  private _msgSource = new Subject<number>();
  message$ = this._msgSource.asObservable();
  constructor() { }

  public sendMessage(msg:number){
    this._msgSource.next(msg);
  }
}
